import React, { useRef } from "react";
import { useRootAppStore } from "@hooks";
import { Button } from "@components/buttons";
import { ButtonProps } from "./types";

export default function RefreshBalanceBtn(props: ButtonProps) {
	const rootStore = useRootAppStore();
	const refreshBtnRef = useRef<HTMLButtonElement>(null);

	const refreshBalance = async () => {
		refreshBtnRef.current?.focus();
		await rootStore.userAuthStore.refreshUserBalance();
		refreshBtnRef.current?.blur();
	};

	return <Button {...props} ref={refreshBtnRef} onClick={refreshBalance} />;
}
